import { useCallback, useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import NavBar from './Components/NavBar';
import NavBarMobile from './Components/NavBarMobile';

/** A requested scroll target on the home page. `nonce` lets the same section be requested twice. */
export interface SectionRequest {
    id: string;
    nonce: number;
}

export interface LayoutContext {
    currentSection: SectionRequest | null;
    goToSection: (id: string) => void;
}

const Layout = () => {
    const [currentSection, setCurrentSection] = useState<SectionRequest | null>(null);
    const navigate = useNavigate();
    const location = useLocation();

    // Home page sections live on "/", so navigate there first when on another page.
    const goToSection = useCallback((id: string) => {
        if (location.pathname !== '/') navigate('/');
        setCurrentSection({ id, nonce: Date.now() });
    }, [location.pathname, navigate]);

    const context: LayoutContext = { currentSection, goToSection };

    return (
        <>
            <div className="video-bg">
                <video autoPlay muted loop playsInline>
                    <source src="/bg1.mp4" type="video/mp4" />
                </video>
                <div className="video-bg-overlay" />
            </div>

            <div className="d-none d-md-block">
                <NavBar goToSection={goToSection} />
            </div>
            <div className="d-block d-md-none">
                <NavBarMobile goToSection={goToSection} />
            </div>

            <main>
                <Outlet context={context} />
            </main>
        </>
    );
};

export default Layout;
